<template>
    <div class="overflow-hidden">
        <SmuToast :toasts="toasts" />
        <SmuMovingBackground context="master" />
        <SmuHeader
            :title="$t('frontend.master_title')"
            :subtitle="$t('frontend.master_administration')"
            class="mb-0!"
        >
            <template #right-side>
                <LanguageDropdown />
            </template>
        </SmuHeader>
        <div class="-m-12 flex min-h-screen items-center justify-center py-16">
            <div
                class="z-10 flex w-1/2 max-w-5xl min-w-96 flex-col items-center justify-center"
            >
                <slot />
            </div>
        </div>
        <div class="fixed inset-x-0 bottom-0 flex items-end justify-center p-4">
            <div
                class="text-dark-text fixed bottom-0 flex justify-center p-4 shadow-lg"
            >
                <PageDefaultFooter />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import {
    SmuHeader,
    SmuMovingBackground,
    SmuToast,
    useToast,
} from "@smakecloud/smake-ui";

const { toasts } = useToast();
</script>
